import Vue from 'vue'
import Router from 'vue-router'
// import layout from '@/views/epc/vw/index.vue'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

// 获取各个项目中router.js路径
var requireModule = require.context('@/router', true, /(\d{2})$/)

var arr = []
for (var i = 0; i < requireModule.keys().length; i++) {
  if (requireModule.keys()[i].substr(2, requireModule.keys()[i].length).split('/').length > 2) {
    arr.push(requireModule.keys()[i].substr(2, requireModule.keys()[i].length) + '/index.js')
  }
}
console.log(arr)
// 获取各个项目中router.js中的数据
let routerArr = []
let routerObj = new Promise(function (resolve, reject) {
  arr.map((item, index) => {
    import(`@/router/${item}`).then(item1 => {
      routerArr = routerArr.concat(item1.default)
      if (index === arr.length - 1) { // 获取所有子路由完毕
        for (var i = 0; i < routerArr.length; i++) {
          for (var j = i + 1; j < routerArr.length; j++) {
            if (JSON.stringify(routerArr[i]) == JSON.stringify(routerArr[j])) { // 第一个等同于第二个，splice方法删除第二个
              routerArr.splice(j, 1)
              j--
            }
          }
        }
        resolve(new Router({
          mode: 'history',
          routes: routerArr
        }))
      }
    })
  })
})

export default routerObj
// 由于路由中的routerArr使用import导入，属于异步导入，所以main.js,和store需要异步处理



// WEBPACK FOOTER //
// ./src/router/common/index.js